import * as React from 'react';
import { Button } from '../Button/Button';

export interface ICardGradientProps {
    title: string;
    subTitle?: string | JSX.Element;
    text?: string;
    image: string;
    btnText?: string;
    label?: string;
    onClick: () => any;
}

export const CardGradient = (props: ICardGradientProps) => {
    const { title, subTitle, text, image, btnText, label, onClick } = props;

    return (
        <div className="cardBox">
            <img src={image} alt="CardBackground" />
            {Boolean(label) && <span className="cardLabel">{label}</span>}
            <div className="content">
                <div className="content-top">
                    <h3>{title}</h3>
                    {Boolean(subTitle) && <span>{subTitle}</span>}
                    {Boolean(text) && <p>{text}</p>}
                </div>
                <div>
                    {Boolean(btnText) && (
                        <Button withArrow onClick={onClick}>
                            {btnText}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};
